export enum ValidityScopeTypeEnum {
  PreOrder = 0,
  ReOrder = 1,
  Both = 2
}
